module.exports = __webpack_public_path__ + "static/media/enGB_add_to_google_wallet_add-wallet-badge.d6395ad1.svg";